import React from 'react';
import { Grid, Typography, Button } from '@mui/material';
import TakePhotoStepper from './TakePhotoStepper';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useEffect, useState } from 'react';
import { replace, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Sidebar from '../components/Sidebar';
import i18next from 'i18next';

function TakePhotoGallery({ capture }) {
  const navigate = useNavigate();
  const location = useLocation();
   let { Topview, Backview, Leftview, Rightview, Frontview } = useSelector(
      (state) => state.user.profile
  );

  useEffect(() => {
    console.log("User name changed dasd:",location);

  }, []); // Runs when "name" changes

  return (
    <div className='takephotogallery photo-container main-section-container'>
      <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
        <Grid item xs={1} className=''>
          <div className='d-flex justify-content-start align-items-center'>

            <span className='backButtonDiv' onClick={() => navigate(-1, { state: { goTo: location?.state?.from }})}>
              <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
            </span>
          </div>
        </Grid>
        <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
          <Typography variant="h6" className="title">{i18next.t("Preview")}</Typography>
        </Grid>
        <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
          <Sidebar/>
        </Grid>

      </Grid>
      <div>
        <TakePhotoStepper capture={(view, type, originfile) => capture(view, type, originfile)} from={location?.state?.from}></TakePhotoStepper>

      </div>
    </div>
  )
}

export default TakePhotoGallery